export const BRAND = {
  name: "Manuel Santana",
  tagline: "Media Personality · Podcast Host · Author",
  domain: "iammanuelsantana.com",
  emails: {
    media: "media@iammanuelsantana.com",
    podcast: "podcast@iammanuelsantana.com",
    business: "business@iammanuelsantana.com",
    general: "hello@iammanuelsantana.com",
    press: "press@iammanuelsantana.com",
  },
  cities: ["New York", "Boston", "Miami", "Atlanta"],
  homeCity: "New York, NY",
  socials: {
    instagram: "https://instagram.com/iammanuelsantana",
    twitter: "https://x.com/iammanuelsantana",
    youtube: "https://youtube.com/@iammanuelsantana",
    tiktok: "https://tiktok.com/@iammanuelsantana",
    spotify: "https://open.spotify.com/show/033rgTfiTjLGPaTefyE3OA",
    apple: "https://podcasts.apple.com/us/podcast/prove-your-point-podcast/id1896911048",
  },
  external: {
    book: "https://www.the12lawsofdatingdynamics.com",
    podcast: "https://www.proveyourpointpodcast.com",
    meetToKeep: "https://meettokeep.com/",
  },
};

export const ASSETS = {
  heroPortrait: "https://customer-assets.emergentagent.com/job_manuel-pro/artifacts/6esznkq8_bm8i9365-edit.png",
  aboutPortrait: "https://customer-assets.emergentagent.com/job_manuel-pro/artifacts/wbrcwwiz_bm8i9380-edit.png",
  podcastPortrait: "https://customer-assets.emergentagent.com/job_manuel-pro/artifacts/whdv08lm_bm8i9421-edit.png",
  bookingPortrait: "https://customer-assets.emergentagent.com/job_manuel-pro/artifacts/lndw26p3_bm8i9504-edit.png",
  bookPortrait: "https://customer-assets.emergentagent.com/job_manuel-pro/artifacts/arpjwk10_bm8i9491-edit.png",
};

export const NAV_LINKS = [
  { id: "home", label: "Home", path: "/" },
  { id: "about", label: "About", path: "/about" },
  { id: "podcast", label: "Podcast", path: "/podcast" },
  { id: "books", label: "Books", path: "/books" },
  { id: "speaking", label: "Speaking", path: "/speaking" },
  { id: "projects", label: "Projects", path: "/projects" },
  { id: "contact", label: "Contact", path: "/contact" },
];

export const PODCAST = {
  name: "The Prove Your Point Podcast",
  short: "Prove Your Point",
  tagline: "Long conversations on relationships, culture and the things we won't say out loud.",
  website: "https://www.proveyourpointpodcast.com",
  spotify: "https://open.spotify.com/show/033rgTfiTjLGPaTefyE3OA",
  apple: "https://podcasts.apple.com/us/podcast/prove-your-point-podcast/id1896911048",
  iheart: "https://www.iheart.com/podcast/269-prove-your-point-podcast-336541374/",
  amazonMusic: "https://music.amazon.com/podcasts/653067bc-2908-4491-9021-7e97017495d4/prove-your-point-podcast",
  youtubeMusic: "https://music.youtube.com/playlist?list=OLSrHAmrIcS_Q57SjoVSd8DZvi1m9ymhB5A",
  trailer: null,
};

export const BOOKS = [
  {
    title: "The 12 Laws of Dating Dynamics",
    subtitle: "How modern men & women can stop guessing and start choosing.",
    released: "2025",
    pages: 305,
    description:
      "Twelve laws — drawn from a decade of interviews, hard lessons and uncomfortable conversations — for navigating modern dating without losing yourself in the process. Required reading for anyone tired of being told what they already know.",
    reviews: [],
    officialSite: "https://www.the12lawsofdatingdynamics.com",
    purchaseLinks: [
      { label: "Amazon", href: "https://www.amazon.com/dp/B0F896WM57" },
      { label: "Barnes & Noble", href: "https://www.barnesandnoble.com/w/the-12-laws-of-dating-dynamics-manuel-santana/1147452155" },
      { label: "Walmart", href: "https://www.walmart.com/ip/The-12-Laws-of-Dating-Dynamics-How-to-Balance-the-Power-and-Avoid-One-sided-Relationships-Paperback-9798218677480/16588800152?classType=REGULAR&from=/search" },
      { label: "Books-A-Million", href: "https://www.booksamillion.com/p/9798218677480" },
    ],
  },
];

export const PROJECTS = [
  {
    name: "The Prove Your Point Podcast",
    role: "Host & Executive Producer",
    summary:
      "Manuel's flagship weekly show. Long-form interviews and solo episodes on relationships, culture, dating and modern manhood.",
    cta: "Visit Site",
    href: "https://www.proveyourpointpodcast.com",
  },
  {
    name: "Meet to Keep",
    role: "Founder",
    summary:
      "An intentional dating app founded by Manuel Santana — built for singles seeking meaningful, long-term relationships through compatibility-based matching and intentional dating features.",
    cta: "Visit Meet to Keep",
    href: "https://meettokeep.com/",
  },
  {
    name: "The 12 Laws of Dating Dynamics",
    role: "Author",
    summary:
      "Manuel Santana's 2025 book — a modern manual for adults navigating dating, partnership and standards. Available everywhere books are sold.",
    cta: "Visit Book Site",
    href: "https://www.the12lawsofdatingdynamics.com",
  },
];

export const SPEAKING_TOPICS = [
  { title: "The Future Of Modern Relationships", body: "What's actually changing, what isn't, and what audiences mishear about both." },
  { title: "Building Media Without Begging The Algorithm", body: "How independent voices outpace legacy outlets — and what it takes operationally." },
  { title: "Men, Standards & Identity", body: "Honest conversation about what young men are reaching for, and what we keep getting wrong about them." },
  { title: "Gender Dynamics In A Loud Decade", body: "Frameworks for talking across the divide without flattening anyone in the process." },
];

export const SEO_TOPICS = {
  "relationship-commentary": {
    h1: "Relationship Commentary",
    tagline: "On love, partnership and the small lies that wreck both.",
    body: [
      "Manuel Santana's relationship commentary cuts across the noise of modern dating discourse. As host of The Prove Your Point Podcast and author of The 12 Laws of Dating Dynamics, Manuel has spent years interviewing couples, therapists, divorcees and matchmakers across New York, Boston, Miami and Atlanta — pulling pattern recognition out of what most media flattens into hot takes.",
    ],
  },
  "dating-advice": {
    h1: "Dating Advice",
    tagline: "Practical, blunt, decade-tested.",
    body: [
      "Manuel Santana's dating advice doesn't pander to either side of the gender conversation. Drawn from years of recorded interviews, in-person events and his book The 12 Laws of Dating Dynamics, his frameworks help adults stop guessing and start choosing.",
      "Through his Meet to Keep dating app and weekly podcast episodes, Manuel offers grounded, non-tribal advice for adults navigating modern dating.",
    ],
  },
  "modern-relationships": {
    h1: "Modern Relationships",
    tagline: "Understanding partnership in a louder, weirder decade.",
    body: [
      "Modern relationships are harder to read, faster to break, and more public than ever. Manuel Santana writes and speaks extensively on how dating apps, social media, economic pressure and shifting gender expectations are rewriting what partnership looks like for millennials and Gen Z.",
      "His commentary on modern relationships is delivered weekly on his flagship show, The Prove Your Point Podcast.",
    ],
  },
  "gender-dynamics": {
    h1: "Gender Dynamics",
    tagline: "Reading the room — and the data — without flattening anyone.",
    body: [
      "Manuel Santana is one of the most cited independent voices in conversations on modern gender dynamics. He has interviewed academics, therapists, dating coaches and everyday couples on the shifting expectations between men and women in dating, marriage and the workplace.",
      "His approach is non-tribal — refusing to flatten either side of the conversation for clicks, and instead pointing audiences toward the underlying patterns most discourse misses.",
    ],
  },
  "men-and-women": {
    h1: "Men and Women",
    tagline: "Honest conversation, both directions.",
    body: [
      "Where most relationship media chooses a team, Manuel Santana refuses to. His work — across The Prove Your Point Podcast, The 12 Laws of Dating Dynamics, and his speaking engagements — is built on talking honestly about what both men and women are actually navigating.",
    ],
  },
  "culture-commentary": {
    h1: "Culture Commentary",
    tagline: "Reading the underwater currents of pop culture.",
    body: [
      "Manuel Santana provides culture commentary on the intersection of relationships, media, identity and modern manhood.",
      "His commentary connects what's happening on Twitter, TikTok and the dating apps to longer-running cultural shifts in family structure, masculinity and intimacy.",
    ],
  },
  "podcast-host": {
    h1: "Podcast Host",
    tagline: "Host of The Prove Your Point Podcast.",
    body: [
      "Manuel Santana is the host and executive producer of The Prove Your Point Podcast — a weekly long-form conversation on relationships, culture, and modern manhood. The show airs across Spotify, Apple Podcasts and YouTube.",
      "Manuel is available for podcast guest appearances, panel hosting and live-event moderation.",
    ],
  },
  "media-personality": {
    h1: "Media Personality",
    tagline: "Built on conversation. Not algorithms.",
    body: [
      "Manuel Santana is an American media personality based between New York, Boston, Miami and Atlanta. Best known as the host of The Prove Your Point Podcast and author of The 12 Laws of Dating Dynamics, he is one of the most-watched independent voices in modern relationship and culture commentary.",
    ],
  },
  "author": {
    h1: "Author",
    tagline: "The 12 Laws of Dating Dynamics — and what comes next.",
    body: [
      "Manuel Santana is the author of the book The 12 Laws of Dating Dynamics (2025), a modern manual for adults navigating dating, partnership and standards.",
      "Manuel is available for author events, festival appearances, signings and long-form interviews.",
    ],
  },
};

export const PRESS_KIT_BIOS = {
  short:
    "Manuel Santana is a New York-based Dominican-American author, podcast host, media personality, and entrepreneur.",
  medium:
    "Manuel Santana is a New York-based Dominican-American author, podcast host, media personality, and entrepreneur whose work explores modern relationships, culture and identity. He is the host of The Prove Your Point Podcast and the author of The 12 Laws of Dating Dynamics.",
  long:
    "Manuel Santana is a New York-based Dominican-American author, podcast host, media personality, and entrepreneur known for his unfiltered commentary on modern relationships, dating, gender dynamics and culture. He is the host of The Prove Your Point Podcast — a weekly long-form conversation available across Spotify, Apple Podcasts and YouTube — and the author of the book The 12 Laws of Dating Dynamics (2025). Manuel is also the founder of Meet to Keep, an intentional dating app for singles seeking meaningful, long-term relationships. He divides his time between New York, Boston, Miami and Atlanta.",
};
